export const INITIAL_BUSINESS_CENTER_REQUEST = "INITIAL_BUSINESS_CENTER_REQUEST";
export const FETCH_BUSINESS_CENTER_SUCCESS = "FETCH_BUSINESS_CENTER_SUCCESS";
export const FINAL_BUSINESS_CENTER_REQUEST = "FINAL_BUSINESS_CENTER_REQUEST";
export const BUSINESS_CENTER_SHOW = "BUSINESS_CENTER_SHOW";
